export const dateTimeFormats = {
    HourMinuteFormat: 'h:mm a',
    MonthDayFormat: 'M/D',
    MonthDayYearFormat: 'M/DD/YYYY',
    MonthDayYearHourMinuteFormat: 'M/d/yyyy h:mm a',

 } as const;

 export const MessageStatusType = {
    delivered: "delivered",
    failed: "failed",
    sent:"sent",
    sending:"sending",
 } as const;

 export const MessageTypeConst = {
   Text: "Text",
   Broadcast: "Broadcast",
   Survey: "Survey",
   VideoCall: "VideoCall",
   PaymentReceived: "PaymentReceived",
   PaymentSent: "PaymentSent",
   PaymentCanceled: "PaymentCanceled",
   PaymentVoided: "PaymentVoided",
   Facebook: "Facebook",
   MergedText: "MergedText"
} as const;


 export const ConversationType = {
    All: {
        Display:"All",
        Value:"all"
    },
    UnRead: {
        Display:"Unread",
        Value:"unread"
    },
    Archive: {
        Display:"Archived",
        Value:"archive"
    }
 } as const;

 export const BroadcastType = {
    EMAIL:"EMAIL",
    MMS:"MMS",
    SMS:"SMS",
 } as const;

 
 export const SurveyConstants = {
    DefaultStartHour:"08",
    DefaultEndHour:"18",
 } as const;

 export const MemoMessageBodyLimit:number = 100;

 export const FeatureNames = {
   Dashboard: "dashboard",
   Broadcasts: "broadcasts",
   Messenger: "messages",
   Surveys: "surveys",
   Feedback: "survey-response",
   Customers: "customers",
   CustomerGroups: "customer-groups",
   Orders: "invoice",
   Settings: "settings",
   Tasks: "tasks",
   Inventory: "inventory",
   Deals: "deals",
   Payments: "payments",
   Automations: "automations"
 } as const;

export const MessagePaymentStatus  = {
   Pending : "Pending",
   Canceled : "Canceled",
   Completed :"Completed",
   PartiallyCompleted :"PartiallyCompleted",
   Voided  :"Voided",
} as const;

export const ApplicationPropertyNames = {
   showTextToPayInvoices:"ShowTextToPayInvoices"
} as const;

export const OrderType = {
   SaleOrder: "SO",
   WorkOrder: "WO",
} as const;

export const AutoSyncSettingsSource = {
   Widget: 'Widget',
   Import: 'Import',
   Customers: 'Customers',
   Messenger: 'Messenger',
   Deals: 'Deals',
};

 export const ConfigConstants = {
   TinyMceApiKey: "api.textEditor",
} as const;
